import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { useRouter } from 'next/router';
import * as React from 'react';

interface ConversationPaginationProps {
	index: string;
	totalPages: number;
	prevPath: string;
	handleNextConversation: () => void;
	handlePrevConversation: () => void;
}

export const ConversationPagination: React.FC<ConversationPaginationProps> = ({
	index,
	totalPages,
	prevPath,
	handleNextConversation,
	handlePrevConversation,
}) => {
	const router = useRouter();
	const { page } = router.query;
	return (
		<div className="flex items-center justify-between w-full pb-6">
			<Link href={`${prevPath}?page=${page}`} type="button">
				<Icon
					src={Icons.arrowLeft}
					className="w-5 h-5 text-[#292D32]"
					width={20}
				/>
			</Link>
			<div className="flex items-center gap-x-6">
				<Typography type="regular-14" className="text-opacity-black">
					{index} of {totalPages}
				</Typography>
				<div className="hidden lg:flex items-center gap-x-8">
					<button
						type="button"
						onClick={handlePrevConversation}
						disabled={Number(index) - 1 <= 0}
						className="disabled:opacity-60"
					>
						<ChevronLeftIcon
							width={24}
							height={24}
							className="text-[#51526C]"
						/>
					</button>
					<button
						type="button"
						onClick={handleNextConversation}
						disabled={Number(index) + 1 > totalPages}
						className="disabled:opacity-60"
					>
						<ChevronRightIcon
							width={24}
							height={24}
							className="text-[#51526C]"
						/>
					</button>
				</div>
			</div>
		</div>
	);
};
